import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { Image, Space, ImageViewer } from 'antd-mobile';
const ImgIndex = (props) => {
    const { imgList, width = 40, height = 40, ...other } = props;
    const [visible, setVisible] = useState(false);
    const [index, setIndex] = useState(0);
    const setShowImg = (n) => {
        setIndex(n);
        setVisible(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Space, { wrap: true, children: imgList.map((item, index) => {
                    return _jsx(Image, { onClick: () => setShowImg(index), src: item, width: width, height: height, ...other }, item);
                }) }), visible && _jsx(ImageViewer.Multi, { images: imgList, visible: visible, defaultIndex: index, onClose: () => {
                    setVisible(false);
                } })] }));
};
export default ImgIndex;
//# sourceMappingURL=index.js.map